import { c as _c } from "react/compiler-runtime";
import { FormEvent, useCallback } from "react";
import { RecaptchaValidation } from "modules/newsletters/components/RecaptchaValidation";
import { usePageProps } from "common/hooks/data/usePageProps";
import type { NewslettersPageProps } from "pages/newsletters/index.page";
import { ErrorResponseFormat, useToggleSubscription } from "modules/newsletters/hooks/useToggleSubscription";
import { useRegionCode } from "modules/i18n/hooks/useRegionCode";
import { useNotifications } from "common/components/NotificationBar/useNotifications";
import { useTranslations } from "modules/i18n/hooks/useTranslations";
import { useAnonymousNewslettersContext, useSubscribedNewslettersContext } from "modules/newsletters/contexts";
import { SubscriptionForm } from "./SubscriptionForm";
import { SuccessMessage } from "./SuccessMessage";
import { StickySubscriptionBar } from "./StickySubscriptionBar";

/**
 * Email input section with subscription form.
 * Shows different states for input, and success.
 */
export const EmailInputSection = () => {
  "use memo";

  const $ = _c(27);
  const {
    locale
  } = usePageProps();
  const {
    email,
    isSubscribed,
    setIsSubscribed,
    recaptchaRef
  } = useAnonymousNewslettersContext();
  const {
    ids: newsletterListIds
  } = useSubscribedNewslettersContext();
  const {
    toggleSubscription,
    isLoading
  } = useToggleSubscription();
  const regionCode = useRegionCode();
  const {
    set: setNotifications
  } = useNotifications();
  const t = useTranslations("newsletters");
  const selectedCount = newsletterListIds.size;
  let t0;
  if ($[0] !== email || $[1] !== newsletterListIds || $[2] !== recaptchaRef || $[3] !== regionCode || $[4] !== selectedCount || $[5] !== setIsSubscribed || $[6] !== setNotifications || $[7] !== t || $[8] !== toggleSubscription) {
    t0 = async e => {
      e?.preventDefault();
      if (!email || selectedCount === 0) {
        return;
      }
      const recaptchaToken = (await recaptchaRef.current?.executeAsync()) ?? undefined;
      ;
      try {
        await toggleSubscription({
          regionCode,
          email,
          action: "subscribe",
          newsletterListIds,
          recaptchaToken
        });
        setIsSubscribed(true);
      } catch (t1) {
        const error = t1;
        const errorMessage = (error as ErrorResponseFormat)?.errors?.[0] ?? t("v2.email_section.error");
        setNotifications([{
          type: "error",
          title: errorMessage
        }]);
      }
    };
    $[0] = email;
    $[1] = newsletterListIds;
    $[2] = recaptchaRef;
    $[3] = regionCode;
    $[4] = selectedCount;
    $[5] = setIsSubscribed;
    $[6] = setNotifications;
    $[7] = t;
    $[8] = toggleSubscription;
    $[9] = t0;
  } else {
    t0 = $[9];
  }
  const handleSubscribe = t0;
  let t1;
  if ($[10] !== locale || $[11] !== recaptchaRef) {
    t1 = <RecaptchaValidation recaptchaRef={recaptchaRef} locale={locale} />;
    $[10] = locale;
    $[11] = recaptchaRef;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  let t2;
  if ($[13] !== isSubscribed || $[14] !== t) {
    t2 = !isSubscribed && <p className="font-serif text-lg leading-relaxed">{t("v2.email_section.description")}</p>;
    $[13] = isSubscribed;
    $[14] = t;
    $[15] = t2;
  } else {
    t2 = $[15];
  }
  let t3;
  if ($[16] !== t2) {
    t3 = <div className="mx-auto max-w-xl pt-4 pb-6 text-center">{t2}</div>;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  let t4;
  if ($[18] !== handleSubscribe || $[19] !== isLoading || $[20] !== isSubscribed || $[21] !== selectedCount) {
    t4 = <StickySubscriptionBar>{isSubscribed ? <SuccessMessage /> : <SubscriptionForm onSubmit={handleSubscribe} isLoading={isLoading} selectedCount={selectedCount} />}</StickySubscriptionBar>;
    $[18] = handleSubscribe;
    $[19] = isLoading;
    $[20] = isSubscribed;
    $[21] = selectedCount;
    $[22] = t4;
  } else {
    t4 = $[22];
  }
  let t5;
  if ($[23] !== t1 || $[24] !== t3 || $[25] !== t4) {
    t5 = <>{t1}{t3}{t4}</>;
    $[23] = t1;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  return t5;
};